import React, { Component } from 'react'

import Immutable from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { getReferralLink } from 'components/SocialLinks/socialReferralHelper'

import { ReferralPresentation } from './ReferralPresentation'

const propTypes = {
  referralCode: PropTypes.string.isRequired,
  rafOffer: ImmutablePropTypes.map({}),
  userFirstName: PropTypes.string,
  userFetchReferralOffer: PropTypes.func,
  trackingReferFriend: PropTypes.func,
  trackingReferFriendSocialSharing: PropTypes.func,
  hasReferralOfferError: PropTypes.bool,
  isLoading: PropTypes.bool,
  device: PropTypes.string,
  trackUserFreeFoodPageView: PropTypes.func,
  trackUserFreeFoodLinkShare: PropTypes.func.isRequired,
  userId: PropTypes.string,
}

const defaultProps = {
  rafOffer: Immutable.Map(),
  userFirstName: '',
  userFetchReferralOffer: () => {},
  trackingReferFriend: () => {},
  trackingReferFriendSocialSharing: () => {},
  hasReferralOfferError: false,
  isLoading: false,
  device: 'desktop',
  trackUserFreeFoodPageView: () => {},
  userId: null,
}

class Referral extends Component {
  componentDidMount() {
    this.fetchReferralOffer()
  }

  componentDidUpdate(prevProps) {
    const { trackUserFreeFoodPageView, userId } = this.props
    if (!prevProps.userId && userId) {
      trackUserFreeFoodPageView()
    }
  }

  fetchReferralOffer = () => {
    const { userFetchReferralOffer } = this.props
    userFetchReferralOffer()
  }

  render() {
    const {
      referralCode,
      rafOffer,
      userFirstName,
      trackingReferFriend,
      trackingReferFriendSocialSharing,
      hasReferralOfferError,
      isLoading,
      device,
      trackUserFreeFoodLinkShare,
    } = this.props
    const offerTitle = rafOffer.get('title')
    const expiry = rafOffer.get('expiry')
    const displayLink = getReferralLink(referralCode)

    return (
      <ReferralPresentation
        device={device}
        displayLink={displayLink}
        expiry={expiry}
        hasError={hasReferralOfferError}
        isLoading={isLoading}
        offerTitle={offerTitle}
        onRetry={this.fetchReferralOffer}
        rafOffer={rafOffer}
        referralCode={referralCode}
        trackingReferFriend={trackingReferFriend}
        trackingReferFriendSocialSharing={trackingReferFriendSocialSharing}
        trackUserFreeFoodLinkShare={trackUserFreeFoodLinkShare}
        userFirstName={userFirstName}
        userRAFLink={displayLink}
      />
    )
  }
}

Referral.propTypes = propTypes

Referral.defaultProps = defaultProps

export { Referral }
